module.exports = __webpack_public_path__ + "my.9771c6056dbb54d56eb4.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/my.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/my.svg
// module chunks = styles